import { dateFormatFr } from '@/utils/data/date'
import {
  DATA_CONTRACT_AGENCY_EDITOR_TOKENS_ADDRESS,
  DATA_CONTRACT_AGENCY_EDITOR_TOKENS_DROPDOWN,
  DATA_CONTRACT_AGENCY_EDITOR_TOKENS_MANAGER,
  DATA_CONTRACT_AGENCY_EDITOR_TOKENS_ROOT,
  generateAddressToken
} from '@/consts/data/contract'

export const DATA_CUSTOMERS_CONTRACTS_EXPIRATIONS_COLUMNS = [
  {
    name: 'customer',
    label: 'Client',
    sortable: true,
    field: 'company',
    format: (val = {}) => val.name,
    classes: 'sticky',
    headerClasses: 'sticky'
  },
  {
    name: 'expirationDate',
    label: 'Expiration',
    field: 'expirationDate',
    format: (v) => dateFormatFr(v),
    sortable: false
  }
]

export const DATA_CUSTOMERS_CONTRACTS_EXPIRATIONS_INDEXED_COLUMNS =
  _.keyBy(DATA_CUSTOMERS_CONTRACTS_EXPIRATIONS_COLUMNS, 'name')

export const DATA_CUSTOMERS_CONTRACTS_EDITOR_TOKENS_ROOT = [
  {
    value: 'customer.email',
    label: `Email du client`
  },
  {
    value: 'customer.name',
    label: `Nom du client`
  },
  {
    value: 'customer.phone',
    label: `Téléphone du client`
  },
  {
    value: 'customer.currency',
    label: `Device de paiement du client`
  }
]
export const DATA_CUSTOMERS_CONTRACTS_EDITOR_TOKENS_ADDRESS =
  generateAddressToken('customer.address', 'du client')

export const DATA_CUSTOMERS_CONTRACTS_EDITOR_TOKENS = [
  ...DATA_CUSTOMERS_CONTRACTS_EDITOR_TOKENS_ROOT,
  ...DATA_CUSTOMERS_CONTRACTS_EDITOR_TOKENS_ADDRESS,
  ...DATA_CONTRACT_AGENCY_EDITOR_TOKENS_ROOT,
  ...DATA_CONTRACT_AGENCY_EDITOR_TOKENS_MANAGER,
  ...DATA_CONTRACT_AGENCY_EDITOR_TOKENS_ADDRESS
]

export const DATA_CUSTOMERS_CONTRACTS_EDITOR_TOKENS_DROPDOWN = [
  {
    label: 'Client',
    sub: true,
    value: 'user',
    data: [
      {
        label: `Addresse`,
        sub: true,
        value: 'customer.address',
        data: [
          {
            value: 'customer.address.city',
            label: `Ville du client`
          },
          {
            value: 'customer.address.country',
            label: `Pays du client`
          },
          {
            value: 'customer.address.street',
            label: `Adresse postal du client`
          },
          {
            value: 'customer.address.zipcode',
            label: `Code postal du client`
          }
        ]
      },
      ...DATA_CUSTOMERS_CONTRACTS_EDITOR_TOKENS_ROOT
    ]
  },
  DATA_CONTRACT_AGENCY_EDITOR_TOKENS_DROPDOWN
]

export const DATA_CUSTOMERS_INDEXED_CONTRACTS_EDITOR_TOKENS = _.keyBy(DATA_CUSTOMERS_CONTRACTS_EDITOR_TOKENS, 'value')
